import React, { Component } from 'react';
import ArrowLeft from 'react-icons/lib/io/ios-arrow-left';

class SlickPrevArrow extends Component {
  render() {
    return <ArrowLeft {...this.props} className='slick-arrow slick-prev-arrow'/>
  }
}

export default SlickPrevArrow;



// WEBPACK FOOTER //
// ./src/components/SlickPrevArrow.js